import React from "react";
import AniLink from "gatsby-plugin-transition-link/AniLink";
import { LogoProps } from "./types";

const Logo: React.FC<LogoProps> = ({ logo, title, dark = false }) => {
  return <h1 className="m-0 p-0 text-[0px]">
    <AniLink paintDrip hex="#111" to="/" className="relative flex items-start">
      <div
        className={`absolute top-[-5px] md:top-[-10px] left-0 [&>svg]:h-[40px] [&>svg]:w-[40px] [&>svg]:md:h-[50px] [&>svg]:md:w-[50px] ${dark ? '[&>svg]:fill-brown' : '[&>svg]:fill-white'}`}
        dangerouslySetInnerHTML={{ __html: logo }}
      />
      <span className={`pl-12 md:pl-14 text-2xl font-serif uppercase ${dark ? 'text-brown' : 'text-white'}`}>{title}</span>
    </AniLink>
  </h1>
}

export default Logo